import { useEffect, useState } from 'react';
import { useApi } from '../../../../hooks/useApi';
import { fmtDate } from '../../../../utils/ruDates';
import { loadFeedbackBilling } from '../../../../services/feedback';
import { errorText, money } from './feedbackUi';

const PERIODS = [[7, '7 дней'], [30, '30 дней'], [90, '90 дней']];
const number = (value) => Number(value || 0).toLocaleString('ru-RU');

function FeedbackBilling({ accountId }) {
    const { request } = useApi();
    const [days, setDays] = useState(30);
    const [data, setData] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        let cancelled = false;
        setError('');
        loadFeedbackBilling({ request, accountId, days })
            .then((result) => !cancelled && setData(result))
            .catch((err) => !cancelled && setError(errorText(err)));
        return () => { cancelled = true; };
    }, [request, accountId, days]);

    if (error) return <p className="muted">{error}</p>;
    if (!data) return <p className="muted">Загрузка…</p>;
    const { rates, totals, daily } = data;

    return (
        <div className="fb" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div className="fb-two">
                <div className="fb-card" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    <h4>Баланс плательщика</h4>
                    <div style={{ fontSize: 28 }}>{data.payer_set ? money(data.balance) : '—'}</div>
                    <div className="fb-note">
                        {data.payer_set
                            ? 'Платные действия ИИ списываются с баланса плательщика кабинета. Пополнить его можно в разделе «Биллинг».'
                            : 'У кабинета не указан плательщик: платные действия ИИ недоступны.'}
                    </div>
                </div>
                <div className="fb-card" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    <h4>Цена за токены</h4>
                    <div>Входящие: {money(rates.input_price_per_million)} за 1 млн</div>
                    <div>Исходящие: {money(rates.output_price_per_million)} за 1 млн</div>
                    <div className="fb-note">Цена складывается из стоимости токенов у поставщика ИИ и нашей наценки.</div>
                </div>
            </div>

            <div className="fb-card" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <h4>Что платно</h4>
                {data.tariffs.map((tariff) => (
                    <div key={tariff.title}><strong>{tariff.title}.</strong> <span className="fb-muted">{tariff.text}</span></div>
                ))}
            </div>

            <div className="fb-card" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <div className="fb-row" style={{ alignItems: 'center', justifyContent: 'space-between' }}>
                    <h4>Расход по дням</h4>
                    <div className="account-tabs account-tabs--secondary">
                        {PERIODS.map(([value, label]) => (
                            <button key={value} type="button" className={days === value ? 'active' : ''} onClick={() => setDays(value)}>{label}</button>
                        ))}
                    </div>
                </div>
                <div className="fb-note">
                    За период: {number(totals.calls)} вызовов, {number(totals.input_tokens)} входящих и {number(totals.output_tokens)} исходящих токенов, списано {money(totals.charged_rub)}.
                </div>
                {daily.length === 0 ? <p className="muted">За этот период ИИ не вызывался.</p> : (
                    <div className="fb-table-wrap"><table className="fb-table">
                        <thead>
                            <tr><th>День</th><th>Ответов</th><th>Отказов</th><th>Анализов</th><th>Токенов</th><th>Списано</th></tr>
                        </thead>
                        <tbody>
                            {daily.map((row) => (
                                <tr key={row.day}>
                                    <td>{fmtDate(row.day)}</td>
                                    <td>{row.replies}</td>
                                    <td>{row.escalations}</td>
                                    <td>{row.analyses}</td>
                                    <td>{number(row.input_tokens + row.output_tokens)}</td>
                                    <td>{money(row.charged_rub)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table></div>
                )}
            </div>
        </div>
    );
}

export default FeedbackBilling;
